// MegaMenu.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../assets/demoNav.css";

const MegaMenu = ({ type, onClose }) => {
    const navigate = useNavigate();

    const menuSidebar = {
        projects: ["Completed Projects", "Ongoing Projects", "Upcoming Projects"],
        career: ["CHANNEL PARTNER", "EMPLOYMENT"],
    };

    const currentSidebar = menuSidebar[type];

    // ======= HOOKS MUST BE FIRST =======
    const [activeContent, setActiveContent] = useState(currentSidebar ? currentSidebar[0] : null);

    // Reset activeContent only when menu type changes
    useEffect(() => {
        if (currentSidebar && currentSidebar.length > 0) {
            setActiveContent(currentSidebar[0]); // default first tab active
        } else {
            setActiveContent(null);
        }
    }, [type]); // <-- only depend on 'type', not currentSidebar

    if (!currentSidebar) return null;

    const handleClick = (item) => {
        setActiveContent(item);
    };

    return (
        <div className="mega-wrapper">
            <div className="mega-menu">
                {/* SIDEBAR */}
                <div className="mega-sidebar">
                    {currentSidebar.map((item) => (
                        <div
                            key={item}
                            className={`sidebar-item ${activeContent === item ? "active" : ""}`}
                            onClick={() => handleClick(item)}
                        >
                            {item}
                        </div>
                    ))}
                </div>

                {/* CONTENT AREA */}
                <div className="mega-content">
                    <div className="mega-header">
                        <div>
                            <h2>{type === "projects" ? "Projects →" : "Career →"}</h2>
                            <p>
                                {type === "projects"
                                    ? "Explore our completed, ongoing, and upcoming projects across Pune and beyond."
                                    : "Join Samriddhi Group and explore employment or partnership opportunities."}
                            </p>
                        </div>
                        <div className="header-right">
                            <span className="close" onClick={onClose}>
                                ✕
                            </span>
                        </div>
                    </div>

                    {/* DYNAMIC CONTENT */}
                    {activeContent && (
                        <div className="mega-columns">
                            {activeContent === "Ongoing Projects" && (
                                <>
                                    <div
                                        className="column feature"
                                        onClick={() => {
                                            navigate("riviera-Greens-dam-view-plots");
                                            onClose();
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <h4>Riviera Greens</h4>
                                        <p>Premium Gunjawani Dam view Farmhouse plots. @Pune Velhe</p>
                                    </div>
                                    <div
                                        className="column feature"
                                        onClick={() => {
                                            navigate("waterscape-premium-water-touch-plots");
                                            onClose();
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <h4>Waterscape</h4>
                                        <p>Breathtaking Water Touch & Water View Farmhouse Plots @Panshet backwaters Pune.</p>
                                    </div>
                                    <a
                                        className="column feature"
                                        href="https://www.lonavalley.in"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}

                                    >
                                        <h4>Lonavalley</h4>
                                        <p>Luxury Resort NA Plots @Lonavala Annexe.</p>
                                    </a>
                                    <div
                                        className="column feature"
                                        onClick={() => {
                                            navigate("/#");
                                            onClose();
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <h4>1 & 2 BHK Elite Homes</h4>
                                        <p>Pocket Friendly Homes in Pune Dhayari & Kirkatwadi.</p>
                                    </div>
                                </>
                            )}

                            {activeContent === "Completed Projects" && (
                                <div className="column feature">
                                    <h5>Completed Projects</h5>
                                    <p>All our past projects delivered on time.</p>
                                </div>
                            )}

                            {activeContent === "Upcoming Projects" && (
                                <div className="column feature">
                                    <h5>Upcoming Projects</h5>
                                    <p>Exciting new projects coming soon!</p>
                                </div>
                            )}

                            {activeContent === "CHANNEL PARTNER" && (
                                <div className="column feature">
                                    <h5>Become a Channel Partner</h5>
                                    <p>Work with Samriddhi Group to grow together.</p>
                                </div>
                            )}

                            {activeContent === "EMPLOYMENT" && (
                                <div className="column feature">
                                    <h5>Employment Opportunities</h5>
                                    <p>Explore our current job openings.</p>

                                     
                                     <h4 className="life_at_sg_btn"><Link to="life-at-samriddhi-group">Life At Samriddhi Group</Link></h4>
                                      <p>Explore Life at Samriddhi Group.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MegaMenu;
